import React from "react";
import { useTranslation } from "react-i18next";
import { User } from "../../../../types";
import LoginButton from "../login";
import Button from "@/components/ui/button";
import { useAuth } from "../../../../hooks/useAuth";
import FormCard from "@/components/common/form-card";

interface AuthenticationSectionProps {
  user?: User;
}

/**
 * Authentication Section - Collapsible User Card Design
 * - Shows login button when logged out
 * - Shows compact user info card when logged in
 * - Includes stats and logout in the same card
 * - Space-efficient and mobile-friendly
 */
const AuthenticationSection: React.FC<AuthenticationSectionProps> = ({
  user,
}) => {
  const { t } = useTranslation("main", { keyPrefix: "profile" });
  const { logout } = useAuth();

  const handleLogout = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    logout({ logoutParams: { returnTo: window.location.href } });
  };

  return (
    <FormCard
      title={!user ? "Welcome!" : user.name}
      description={
        !user
          ? "to save settings, track stories and access your membership, please..."
          : `Stories: ${user.rank ?? 0}`
      }
    >
      <div className="flex items-center justify-end gap-3">
        {!user ? (
          <LoginButton disabled={false} displayText={t("body.logIn")} />
        ) : (
          <Button size="lg" type="button" onClick={handleLogout}>
            LOG OUT
          </Button>
        )}
      </div>
    </FormCard>
  );
};

export default AuthenticationSection;
